import { lazy } from 'react';

const Processors = lazy(() => import('./AdminProcessorsPage'));

const AdminProcessorsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'admin/processor',
      element: <Processors />,
    },
  ],
};

export default AdminProcessorsConfig;
